import { defineComponent as _defineComponent } from 'vue'
interface Props {
  text?: string;
  disabled?: boolean;
  colorRed?: boolean;
  loading?: boolean;
  nuxt?: boolean;
  to?: string;
  replace?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TextBtn',
  props: {
    text: null,
    disabled: { type: Boolean },
    colorRed: { type: Boolean },
    loading: { type: Boolean },
    nuxt: { type: Boolean, default: false },
    to: { default: undefined },
    replace: { type: Boolean, default: false }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})